import { ControlLabel, FormGroup, Input } from 'rsuite';
import styles from './NomeMonitoramentoForm.module.scss';

type NomeMonitoramentoFormProps = {
  value: string;
  onChange: (value: string) => void;
  hideHeader?: boolean;
};

export const NomeMonitoramentoForm = ({ value, onChange, hideHeader = false }: NomeMonitoramentoFormProps) => {
  return (
    <div className={styles.container}>
      {!hideHeader && <h2 className={styles.title}>Criar novo monitoramento</h2>}
      <FormGroup className={styles.formGroup}>
        <ControlLabel className={styles.label}>Nome do monitoramento</ControlLabel>
        <Input className={styles.input} placeholder="Insira um nome para o seu o seu monitoramento" value={value} onChange={onChange} />
      </FormGroup>
    </div>
  );
};
